import { FC, useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { http } from "../../http";
import { API_BASE_URL } from "Constants";
import CouponsTable from "Components/Sponsor/CouponsTable";
import { Coupon } from "Types/App";
import { AdminPage, AdminError, BackLink, PrimaryButton, EmptyState } from "./adminShared";

type CouponsPageProps = {};

interface CouponsResponse {
  coupons: Coupon[];
}

export const CouponsPage: FC<CouponsPageProps> = () => {
  const history = useHistory();
  const [error, setError] = useState<string>("");
  const [coupons, setCoupons] = useState<Coupon[]>([]);
  const [userCode, setUserCode] = useState("");
  const [loaded, setLoaded] = useState<boolean>(false);

  const { hub_id } = useParams<{ hub_id: string }>();

  useEffect(() => {
    const getCoupons = async () => {
      try {
        const response = await http<CouponsResponse>(API_BASE_URL + `/sponsor/hubs/${hub_id}/coupons`, "GET");
        const body = response.parsedBody;
        if (!body) {
          setError("response error");
          return;
        }
        setCoupons(body.coupons);
      } catch (ex: any) {
        setError(ex.toString());
      } finally {
        setLoaded(true);
      }
    };
    getCoupons();
  }, [hub_id]);

  const handlePrintClick = async (hubId: number, couponId: number) => {
    try {
      const response = await http<any>(API_BASE_URL + `/sponsor/hubs/${hubId}/coupons/${couponId}/print`, "GET");
      const body = response.parsedBody;
      if (!body) {
        setError("response error");
        return;
      }
      setUserCode(body.user_code);
    } catch (ex: any) {
      setError(ex.toString());
    }
  };

  const handleStampQRcodePrintClick = async (hubId: number, couponId: number) => {
    try {
      const response = await http<any>(API_BASE_URL + `/sponsor/hubs/${hubId}/coupons/${couponId}/print/stamp_rally`, "GET");
      const body = response.parsedBody;
      if (!body) {
        setError("response error");
        return;
      }
      setUserCode(body.user_code);
      alert("ネットプリント印刷IDが発行されました。メールでお知らせします。");
    } catch (ex: any) {
      setError(ex.toString());
    }
  };

  return (
    <AdminPage
      eyebrow="COUPONS"
      title="クーポン一覧"
      icon="ticket"
      action={
        <PrimaryButton icon="plus" onClick={() => history.push("/sponsor/hubs/" + hub_id + "/coupons/add")}>
          クーポンを作成
        </PrimaryButton>
      }
    >
      <BackLink to="/sponsor/hubs">店舗一覧に戻る</BackLink>
      <AdminError error={error} />
      {loaded && coupons.length === 0 ? (
        <EmptyState
          icon="ticket"
          title="まだクーポンがありません"
          description="この店舗の最初のクーポンを作成しましょう。"
          action={
            <PrimaryButton icon="plus" onClick={() => history.push("/sponsor/hubs/" + hub_id + "/coupons/add")}>
              クーポンを作成
            </PrimaryButton>
          }
        />
      ) : (
        <CouponsTable
          coupons={coupons}
          handlePrintClick={handlePrintClick}
          handleStampQRcodePrintClick={handleStampQRcodePrintClick}
          userCode={userCode}
          setUserCode={setUserCode}
        />
      )}
    </AdminPage>
  );
};
